import styled from "@emotion/styled";

import { BREAKPOINTS, media } from "../constants";
import { Div } from "./layout";
import { Image } from "./media";

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  width: ${(props) => props.width || "100%"};
  gap: ${(props) => props.gap || "15px"};
  align-items: ${(props) => props.align || "center"};
`;

export const Input = styled.input`
  height: 45px;
  border: 1px solid ${({ theme }) => theme.custom.grayInputs};
  border-radius: 30px;
  padding: 10px 20px;
  width: ${(props) => props.width || "100%"};
  font-size: 16px;
  font-family: ${({ theme }) => theme.typography.fontFamily};
  margin-top: ${(props) => props.marginTop || ""};
`;

export const EditFormDiv = styled(Div)`
  label: edit-form-div;
  flex-direction: ${(props) => props.direction || "row"};
  justify-content: space-between;
  border-bottom: ${({ theme, borderBottom }) =>
    borderBottom || `1px solid ${theme.custom.grayLight}`};
  padding-bottom: ${(props) => props.paddingBottom || "20px"};
  flex-wrap: ${(props) => props.wrap || ""};

  ${media.max(BREAKPOINTS.mobileMax)} {
    justify-content: space-between;
  }
`;

export const EditFormInput = styled(Input)`
  width: ${(props) => props.width || "150px"};
  border: none;
  background-color: ${({ theme }) => theme.palette.background.lightGray};
  height: ${({ $multiline }) => ($multiline ? "auto" : "35px")};
  line-height: 1.4;
  resize: ${({ $multiline }) => ($multiline ? "vertical" : "none")};
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;

  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }
`;

export const EditFormTextarea = styled.textarea`
  width: ${(props) => props.width || "150px"};
  border: none;
  padding: 10px 20px;
  background-color: ${({ theme }) => theme.palette.background.lightGray};
  border-radius: ${(props) => props.borderRadius || "30px"};
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  font-size: 16px;
  font-family: ${({ theme }) => theme.typography.fontFamily};
  line-height: 1.4;
  resize: vertical;
`;

export const FormInputIcon = styled(Image)`
  position: absolute;
  right: 15px;
  top: ${(props) => props.top || "50%"};
  transform: ${(props) => props.transform || "translateY(-50%)"};
  pointer-events: none;
  font-size: 18px;
  color: #999;
`;

export const FeedbackFormDiv = styled(Div)`
  label: feedback-form-div;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  padding-bottom: ${(props) => props.paddingBottom || "0"};
  flex-wrap: ${(props) => props.wrap || ""};
`;

export const FeedbackFormInput = styled(Input)`
  label: feedback-form-input;
  width: ${(props) => props.width || "100%"};
  border: ${({ theme, $outlined }) =>
    $outlined ? `1px solid ${theme.custom.grayInputs}` : 'none'};
  background-color: ${({ theme }) => theme.custom.white};
  height: ${({ $multiline }) => ($multiline ? "auto" : "35px")};
  line-height: 1.4;
  resize: ${({ $multiline }) => ($multiline ? "vertical" : "none")};
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  border-radius: ${({ $outlined }) => ($outlined ? '8px' : '5px')};
  font-size: 14px;
  box-sizing: border-box;

  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }
`;

export const FeedbackFormTextarea = styled.textarea`
  label: feedback-form-textarea;
  width: 100%;
  border: ${({ theme, $outlined }) =>
    $outlined ? `1px solid ${theme.custom.grayInputs}` : 'none'};
  padding: 10px 20px;
  background-color: ${({ theme }) => theme.custom.white};
  border-radius: ${({ $outlined }) => ($outlined ? '8px' : '8px')};
  box-sizing: border-box;
  white-space: pre-wrap;
  overflow-wrap: break-word;
  word-break: break-word;
  overflow: auto;
  font-size: 14px;
  font-family: ${({ theme }) => theme.typography.fontFamily};
  line-height: 1.4;
  resize: vertical;
`;

export const FeedbackFormSubtitle = styled.p`
  margin: 0 0 4px;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.45;
  text-align: left;
  width: 100%;
  color: ${({ theme }) => theme.palette.text.primary};
`;

export const FeedbackFormPanel = styled.div`
  label: feedback-form-panel;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 16px 18px;
  border-radius: 12px;
  background-color: ${({ theme }) => theme.palette.background.lightGray};
  box-sizing: border-box;
`;

export const SwitchContainer = styled.label`
  position: relative;
  display: inline-block;
  width: 50px;
  height: 28px;
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
`;

export const SwitchInput = styled.input`
  opacity: 0;
  width: 0;
  height: 0;

  &:checked + .switch-slider {
    background-color: ${({ theme }) => theme.palette.primary.main || "#4caf50"};
  }

  &:checked + .switch-slider:before {
    transform: translateX(22px);
  }

  &:focus + .switch-slider {
    box-shadow: 0 0 1px ${({ theme }) => theme.palette.primary.main || "#4caf50"};
  }
`;

export const SwitchSlider = styled.span`
  position: absolute;
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${({ theme }) => theme.custom.grayInputs || "#ccc"};
  transition: 0.3s;
  border-radius: 28px;

  &:before {
    position: absolute;
    content: "";
    height: 22px;
    width: 22px;
    left: 3px;
    bottom: 3px;
    background-color: white;
    transition: 0.3s;
    border-radius: 50%;
  }
`;


